<template>
  <div class="spl-subheader-dashboard">
    <div class="row">
      <div class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__label">
          Welcome back, {{ userIdentity ? userIdentity.Name : '' }}!
        </div>
        <div class="spl-subheader-dashboard__sublabel">
          Here is your {{ timeOfDay }} parcel status
        </div>
      </div>
      <!-- *********************** Precarriage: Not Collected *********************************** -->
      <div v-if="precarriage_Mode()" class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__red-label">
          Not Collected
        </div>
        <div class="spl-subheader-dashboard__red-value" @click="openParcelList(constants.PARCEL_STATUS.NOT_COLLECTED)">
          {{ dashboardData.Not_Collected }}
        </div>
      </div>
      <!-- *********************** Distribution: Late *********************************** -->
      <div v-if="distribution_Mode()" class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__red-label">
          Late
        </div>
        <div class="spl-subheader-dashboard__red-value" @click="openParcelList(constants.PARCEL_STATUS.LATE)">
          {{ dashboardData.Late }}
        </div>
      </div>
      <!-- *********************** Precarriage: Not Booked *********************************** -->
      <div v-if="precarriage_Mode()" class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__blue-label">
          Not Booked
        </div>
        <div class="spl-subheader-dashboard__blue-value" @click="openParcelList(constants.PARCEL_STATUS.NOT_BOOKED)">
          {{ dashboardData.Not_Booked }}
        </div>
      </div>
      <!-- *********************** Distribution: External Delay *********************************** -->
      <div v-if="distribution_Mode()" class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__blue-label">
          External Delay
        </div>
        <div class="spl-subheader-dashboard__blue-value" @click="openParcelList(constants.PARCEL_STATUS.EXTERNAL_DELAY)">
          {{ dashboardData.External_Delay }}
        </div>
      </div>
      <!-- *********************** Precarriage: Collected *********************************** -->
      <div v-if="precarriage_Mode()" class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__light-grey-label">
          Collected
        </div>
        <div class="spl-subheader-dashboard__light-grey-value" @click="openParcelList(constants.PARCEL_STATUS.COLLECTED)">
          {{ dashboardData.Collected }}
        </div>
      </div>
      <!-- *********************** Distribution: Delivered *********************************** -->
      <div v-if="distribution_Mode()" class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__light-grey-label">
          Delivered
        </div>
        <div class="spl-subheader-dashboard__light-grey-value" @click="openParcelList(constants.PARCEL_STATUS.DELIVERED)">
          {{ dashboardData.Delivered }}
        </div>
      </div>
      <!-- *********************** Total*********************************** -->
      <div class="spl-subheader-dashboard-col">
        <div class="spl-subheader-dashboard__grey-label">
          Total
        </div>
        <div class="spl-subheader-dashboard__grey-value" @click="openParcelList(constants.PARCEL_STATUS.ALL)">
          {{ dashboardData.Total }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SubheaderDashboard',
  props: {
    dashboardData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      constants,
      name: 'Dude',
      view_mode: 'Precarriage',
      timeOfDay: 'current'
    }
  },
  computed: {
    ...mapGetters('parcelFilter', ['parcelFilter']),
    ...mapState('user', ['userIdentity'])
  },
  watch: {
    dashboardData: function (newDashboardSummary) {
      // Only show precarriage if it is the same day
      if (moment(this.parcelFilter('dashboard').From_Date).isSame(moment(), 'day')) {
        this.view_mode = 'Precarriage'
      } else {
        this.view_mode = 'Distribution'
      }
      this.dashboardData = newDashboardSummary
    },
    view_mode: function (newValue) {
      this.view_mode = newValue
    }

  },
  methods: {
    // *********************** Open Pacel List ***********************************
    openParcelList: function (statusId) {
      // Create the filter options needed in the parcel list
      var selectedOptions = {
        from_date: this.parcelFilter('dashboard').From_Date,
        to_date: this.parcelFilter('dashboard').To_Date,
        customer_id: this.parcelFilter('dashboard').Customers,
        country_id: this.parcelFilter('dashboard').Countries,
        tags: this.parcelFilter('dashboard').Tags,
        providers: this.parcelFilter('dashboard').Providers,
        service_level_id: this.parcelFilter('dashboard').Service_Levels,
        status: statusId,
        current_event_infos: this.parcelFilter('dashboard').Current_Event_Infos,
        show_forward_flow: this.parcelFilter('dashboard').Show_Forward_Flow,
        from_postal_code: this.parcelFilter('dashboard').From_Postal_Code,
        to_postal_code: this.parcelFilter('dashboard').To_Postal_Code
      }
      this.$router.replace({ name: 'parcel-list', params: selectedOptions })
    },
    precarriage_Mode () {
      if (!this.view_mode) return true
      return this.view_mode === 'Precarriage'
    },
    distribution_Mode () {
      if (!this.view_mode) return false
      return this.view_mode === 'Distribution'
    }

  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-subheader-dashboard {
        background-color: $yellowButtonLabelHover;
        height: 140px;
        margin-bottom:1px;
        padding: 40px $mainPadding;
        width: 100%;

        @include mobile() {
            display: none;
        }
        &__label,
        &__sublabel {
            color: $headerLatestUpdatesLabelColor;
            font-size: 16px;
            font-weight: 600;
        }
        &__sublabel {
            color: $headerLatestUpdatesDateColor;
        }
        &-col {
            float: left;
            padding: 0 40px 0 0;
            vertical-align: top;

            @include mobile() {
                padding: 0 0 0 10px;
                width: 25%;
            }
        }
        &__red-label,
        &__blue-label,
        &__light-grey-label,
        &__grey-label {
            font-family: $mono;
            font-size: 9px;
            font-weight: 700;
            line-height: 12px;
            letter-spacing: 1px;
            text-transform: uppercase;

            @include mobile() {
                font-size: 8px;
            }
        }
        &__red-value,
        &__blue-value,
        &__light-grey-value,
        &__grey-value {
            font-size: 45px;

            @include mobile() {
                font-size: 20px;
            }
        }
        &__red-label,
        &__red-value {
            color: $red;
        }
        &__blue-label,
        &__blue-value {
            color: $blue;
        }
        &__light-grey-label,
        &__light-grey-value {
            color: $headerLatestUpdatesDateColor;
        }
        &__grey-label,
        &__grey-value {
            color: $headerDashboardGreyColor;
        }
    }

</style>
